import { isAppWebView, isMiniWebView } from '@/utils';

export default {
  install(Vue) {
    function changeHeader() {
      if (this._hasMetaInfo) { // eslint-disable-line no-underscore-dangle
        // web view 中不需展示头部
        if (isAppWebView() || isMiniWebView()) {
          this.$store.dispatch('toggleCustomizeHeader', true);
          return;
        }
        const { name } = this.$options;
        const { metaInfo } = this.$options;
        if (this.$metaInfo && name !== 'App') {
          this.$store.dispatch('changeTitle', this.$metaInfo.title || '');
          this.$watch('$metaInfo', (val) => {
            const { title } = val;
            this.$store.dispatch('toggleCustomizeHeader', false);
            this.$store.dispatch('changeTitle', title);
          });
          return;
        }
        const { title } = metaInfo;
        if (title === undefined) {
          this.$store.dispatch('toggleCustomizeHeader', true);
          return;
        }
        if (metaInfo && name !== 'App') {
          this.$store.dispatch('toggleCustomizeHeader', false);
          this.$store.dispatch('changeTitle', title);
        }
      }
    }

    Vue.mixin({
      mounted() {
        changeHeader.call(this);
      },
      activated() {
        changeHeader.call(this);
      },
      beforeRouteUpdate(to, from, next) {
        changeHeader.call(this);
        next();
      },
    });
  },
};
